import { render, staticRenderFns } from "./PersonProfileHistoryLocationInfoDetails.vue?vue&type=template&id=d56ca3de&scoped=true&"
import script from "./PersonProfileHistoryLocationInfoDetails.vue?vue&type=script&lang=js&"
export * from "./PersonProfileHistoryLocationInfoDetails.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileHistoryLocationInfoDetails.vue?vue&type=style&index=0&id=d56ca3de&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56ca3de",
  null
  
)

export default component.exports